import { useLocalSearchParams } from 'expo-router'

import { useCommunityJoinSearchParams } from '@/src/features/community/ui/hooks/useCommunityJoinSearchParams'
import { CommunityJoinNextIntentionsPrayScreen } from '@/src/features/community/ui/screens/CommunityJoinNextIntentionPrayScreen'

const CommunityJoinNextIntentionPrayRouterPage = () => {
  const { intentionIdToken } = useLocalSearchParams<{ intentionIdToken: TIdDashSlug }>()
  const { idSlug, course, origin, source } = useCommunityJoinSearchParams()

  if (!intentionIdToken || !idSlug) {
    return null
  }

  return (
    <CommunityJoinNextIntentionsPrayScreen
      idSlug={idSlug}
      intentionIdToken={intentionIdToken}
      course={course}
      origin={origin}
      source={source}
    />
  )
}

export default CommunityJoinNextIntentionPrayRouterPage
